import { createContext } from 'react'

export const ThemeContext = createContext({
  // key: 'light',
  theme: {},
  setTheme: (_: string) => {
    //
  },
})
